/* eslint-disable indent */
import styled from 'styled-components';
import { MenuItem, ListSubheader, IconButton } from '@mui/material';

import { COLORS } from '../../../theme';

export const MenuItemContent = styled('div')`
  display: flex;
  flex-direction: ${({ adornmentPlace }) =>
    adornmentPlace === 'left' ? 'inherit' : 'row-reverse'};
  justify-content: ${({ adornmentPlace }) =>
    adornmentPlace === 'left' ? 'inherit' : 'space-between'};
  width: 100%;
  text-wrap: wrap;
`;

export const StyledMenuItem = styled(MenuItem)`
  > div .MuiSvgIcon-root {
    width: ${({ theme }) => theme.fontSize.body1};
    margin-right: ${({ theme }) => theme.spacing.s1};
  }

  ${({ $selected, theme }) =>
    $selected &&
    `
    &&&.MuiAutocomplete-option[aria-selected='true'],
    &&.Mui-selected {
      position: relative;
      color: ${COLORS.kinetikBlack};
      font-weight: 500;
      background-color: transparent;

      && {
        padding-right: ${theme.spacing.l1};
      }

      &::after {
        position: absolute;
        top: 50%;
        right: ${theme.spacing.s4};
        width: 6px;
        height: 12px;
        border: 1px solid ${COLORS.kinetikBlack};
        border-width: 0 2px 2px 0;
        border-radius: 1px;
        transform: translateY(-65%) rotate(45deg);
        content: '';
      }
    }
  `}
`;

export const SearchWrapper = styled(ListSubheader)`
  &&&& {
    padding: ${({ theme }) => theme.spacing.s1}
      ${({ theme }) => theme.spacing.s1} 0;
  }
`;

export const StyledIconComponent = styled(IconButton)`
  && {
    padding: 0;
    background-color: transparent;
  }
`;
